import "core-js/modules/es.object.to-string";
import { ROUTE_NAME } from '@/lib/constant';
import Loading from '@/pages/extra/loading.vue';
export default [{
  path: '/feedback',
  name: ROUTE_NAME.FEEDBACK,
  meta: {
    title: '问题反馈'
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "feedback" */
      '@/pages/feedback/feedback.vue'),
      loading: Loading
    };
  }
}, {
  path: '/feedback/report',
  name: ROUTE_NAME.FEEDBACK_REPORT,
  meta: {
    title: '问题反馈'
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "feedback" */
      '@/pages/feedback/report.vue'),
      loading: Loading
    };
  }
}, {
  path: '/feedback/report_result',
  name: ROUTE_NAME.FEEDBACK_REPORT_RESULT,
  meta: {
    title: '反馈结果'
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "feedback" */
      '@/pages/feedback/reportResult.vue'),
      loading: Loading
    };
  }
}, {
  path: '/feedback/category/:categoryId/:questionIndex?',
  name: ROUTE_NAME.FEEDBACK_CATEGORY,
  meta: {
    title: '问题反馈'
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "feedback" */
      '@/pages/feedback/category.vue'),
      loading: Loading
    };
  }
}, {
  path: '/feedback/signin_appeal/:signInId?',
  name: ROUTE_NAME.FEEDBACK_SIGNIN_APPEAL,
  meta: {
    title: '我要申诉'
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "feedback" */
      '@/pages/feedback/signInAppeal.vue'),
      loading: Loading
    };
  }
}];